import { useState } from "react";
import { Outlet, Link, useLocation } from "react-router";
import { Home, NotebookPen, TriangleAlert, LogIn, Menu, X, ExternalLink, Globe } from "lucide-react";
import BpsLogo from "../components/BpsLogo";

export default function PublicLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/", label: "Beranda", icon: Home },
    { to: "/buku-tamu", label: "Buku Tamu", icon: NotebookPen },
    { to: "/pengaduan", label: "Pengaduan", icon: TriangleAlert },
    { to: "/login", label: "Login Petugas", icon: LogIn },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <header className="bg-[#003580] text-white shadow-lg sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between h-14">
            <Link to="/" className="flex items-center gap-2 min-w-0">
              <BpsLogo size={32} />
              <div className="min-w-0">
                <div className="text-xs" style={{fontWeight:700, lineHeight:"1.2"}}>PST BPS</div>
                <div className="text-[10px] opacity-80 truncate">Kabupaten Lombok Tengah</div>
              </div>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`flex items-center gap-1 px-3 py-2 rounded-lg text-sm transition-colors ${
                    isActive(link.to) ? "bg-white/20 text-white" : "hover:bg-white/10 text-white/90"
                  }`}
                >
                  <link.icon size={15} />
                  <span>{link.label}</span>
                </Link>
              ))}
              <a
                href="https://lomboktengahkab.bps.go.id"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1 px-3 py-2 rounded-lg text-sm text-white/90 hover:bg-white/10 transition-colors"
              >
                <Globe size={15} />
                <span>Website BPS</span>
                <ExternalLink size={11} />
              </a>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-white/10 transition-colors"
            >
              {menuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <div className="md:hidden border-t border-white/20 py-2 pb-3 space-y-1">
              {navLinks.map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm transition-colors ${
                    isActive(link.to) ? "bg-white/20" : "hover:bg-white/10"
                  }`}
                >
                  <link.icon size={16} />
                  <span>{link.label}</span>
                </Link>
              ))}
              <a
                href="https://lomboktengahkab.bps.go.id"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm hover:bg-white/10 transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                <Globe size={16} />
                <span>Website Resmi BPS Kabupaten Lombok Tengah</span>
                <ExternalLink size={12} />
              </a>
            </div>
          )}
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-[#003580] text-white py-4 px-4 text-center text-xs opacity-90 mt-auto">
        <p style={{fontWeight:600}}>Pelayanan Statistik Terpadu (PST)</p>
        <p className="opacity-80">BPS Kabupaten Lombok Tengah | Jl. Kalimantan No. 2, Praya</p>
        <p className="opacity-70 mt-1">© 2026 Badan Pusat Statistik Kabupaten Lombok Tengah. All rights reserved.</p>
      </footer>
    </div>
  );
}
